package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Search: ImageVector
    get() {
        if (_search != null) {
            return _search!!
        }
        _search = Builder(name = "Search", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
                viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(9.482f, 0.0f)
                    curveTo(14.75f, 0.0f, 18.964f, 4.214f, 18.964f, 9.482f)
                    curveTo(18.964f, 11.336f, 18.437f, 13.064f, 17.51f, 14.539f)
                    lineTo(24.0f, 21.071f)
                    lineTo(21.071f, 24.0f)
                    lineTo(14.497f, 17.531f)
                    curveTo(13.043f, 18.437f, 11.315f, 18.964f, 9.482f, 18.964f)
                    curveTo(4.214f, 18.964f, 0.0f, 14.75f, 0.0f, 9.482f)
                    curveTo(0.0f, 4.214f, 4.214f, 0.0f, 9.482f, 0.0f)
                    close()
                    moveTo(9.482f, 4.214f)
                    curveTo(6.573f, 4.214f, 4.214f, 6.573f, 4.214f, 9.482f)
                    curveTo(4.214f, 12.391f, 6.573f, 14.75f, 9.482f, 14.75f)
                    curveTo(12.391f, 14.75f, 14.75f, 12.391f, 14.75f, 9.482f)
                    curveTo(14.75f, 6.573f, 12.391f, 4.214f, 9.482f, 4.214f)
                    close()
                }
            }
        }
        .build()
        return _search!!
    }

private var _search: ImageVector? = null
